import { Controller } from '@hotwired/stimulus';
import { wrapPrivateKeyWithPassword, b64encode } from '../vault_crypto';

export default class extends Controller {
  static targets = [
    'currentPassword',
    'newPassword',
    'confirmationField',
    'passwordError',
    'wrappedPrivateKey',
    'salt',
    'iv',
  ];
  static values = { cryptoOptions: Object, minLength: Number, t: Object };

  async changePassword(event) {
    event.preventDefault();

    const current = this.currentPasswordTarget.value;
    const newPw = this.newPasswordTarget.value;
    const confirm = this.confirmationFieldTarget.value;
    const minLen = this.minLengthValue || 12;

    if (!current) {
      alert(this.tValue.current_password_required);
      return;
    }
    if (newPw.length < minLen) {
      alert(this.tValue.password_too_short);
      return;
    }
    if (newPw !== confirm) {
      alert(this.tValue.passwords_do_not_match);
      return;
    }

    try {
      const opts = this.cryptoOptionsValue;
      const decryptor = new Decrypt({
        user_wrapped_private_key: opts.user_wrapped_private_key,
        user_salt: opts.user_salt,
        user_iv: opts.user_iv,
        encrypted_org_private_key: opts.encrypted_org_private_key,
        enc_shared_keys: [],
      });
      const userPriv = await decryptor.unwrapPrivateKey(current);
      const { wrappedKey, salt, iv } = await wrapPrivateKeyWithPassword(newPw, userPriv);

      this.wrappedPrivateKeyTarget.value = b64encode(wrappedKey);
      this.saltTarget.value = b64encode(salt);
      this.ivTarget.value = b64encode(iv);

      this.currentPasswordTarget.disabled = true;
      this.newPasswordTarget.disabled = true;
      this.confirmationFieldTarget.disabled = true;
      this.element.submit();
    } catch (e) {
      console.error('Change password failed:', e);
      alert(this.tValue.invalid_password);
    }
  }
}
